import { render, staticRenderFns } from "./manjamSettings.vue?vue&type=template&id=5009cffb&"
import script from "./manjamSettings.vue?vue&type=script&lang=js&"
export * from "./manjamSettings.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports